import React, { useState } from "react";

import { IconInformation } from "@at/design-system-icons";
import { Modal, ModalVariant } from "@at/design-system-patterns";

import { FullChargeInfoExplained } from "./full-charge-info-explained";
import { useTracking } from "../../../../utils/tracking/use-tracking";
import { InfoButtonStyled } from "../charging.styles";

const FullChargeInfoModal = () => {
  const [visible, setVisible] = useState(false);
  const { trackModalEvent } = useTracking();

  return (
    <>
      <InfoButtonStyled
        data-testid="optimised-battery-charging-info"
        onClick={() => setVisible(true)}
        aria-label="Info about optimised battery charging"
      >
        <IconInformation title={""} customSize={{ width: 18, height: 18 }} />
      </InfoButtonStyled>

      <Modal
        isShowing={visible}
        hasBackLink={false}
        closeText="Back"
        variation={ModalVariant.SLIDE}
        hideFn={() => setVisible(false)}
        overlayName="full-charge"
        trackingCallback={({ modalAction }) => {
          trackModalEvent({ trackingLabel: "full-charge", modalAction });
        }}
      >
        <FullChargeInfoExplained />
      </Modal>
    </>
  );
};

export default FullChargeInfoModal;
